import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {adminWorkerRequestListAPI} from "../../../services/admin";
import styles from "../project/AdminProject.module.css";
import {ChevronLeftIcon, ChevronRightIcon} from "@heroicons/react/24/outline";
import AdminWorkerRequestInfo from "./AdminWorkerRequestInfo";

interface AdminWorkerRequestProps {
    workerRequestId: number;
}

//작업자 추가 요청 상세 페이지 버튼
const AdminWorkerRequest: React.FC<AdminWorkerRequestProps> = ({workerRequestId}) => {
    const navigate = useNavigate();
    const [workerRequestIds, setWorkerRequestIds] = useState<number[]>([]);
    const [currentIndex, setCurrentIndex] = useState<number>(0);

    useEffect(() => {
        const fetchRequests = async () => {
            try {
                //요청 식별자 목록 API
                const response = await adminWorkerRequestListAPI();
                setWorkerRequestIds(response);
                const index = response.findIndex(wid => wid === workerRequestId);
                setCurrentIndex(index);
            } catch (error) {
                console.log(error);
            }
        }
        fetchRequests();
    }, [workerRequestId]);

    //이전 요청 페이지
    const handlePrevious = () => {
        if (currentIndex > 0) {
            const prevRequestId = workerRequestIds[currentIndex - 1];
            navigate(`/admin/billing/worker-request/${prevRequestId}`);
        }
    };

    //다음 요청 페이지
    const handleNext = () => {
        if (currentIndex < workerRequestIds.length - 1) {
            const nextRequestId = workerRequestIds[currentIndex + 1];
            navigate(`/admin/billing/worker-request/${nextRequestId}`);
        }
    };

    //작업자 추가 요청 식별자가 없을 경우
    if (!workerRequestId) {
        return <div>Invalid project ID</div>;
    }

    return (
        <div className={styles.container}>
            <div className={styles.navigationContainer}>
                {/*이전 요청 버튼*/}
                <button
                    className={`${styles.navButton} ${currentIndex === 0 ? styles.disabled : ''}`}
                    onClick={handlePrevious}
                    disabled={currentIndex === 0}
                    aria-label="Previous request"
                >
                    <ChevronLeftIcon className={styles.navIcon}/>
                </button>

                <div className={styles.contentWrapper}>
                    {/*작업자 추가 요청 정보*/}
                    <AdminWorkerRequestInfo workerRequestId={workerRequestId}/>
                </div>

                {/*다음 요청 버튼*/}
                <button
                    className={`${styles.navButton} ${currentIndex === workerRequestIds.length - 1 ? styles.disabled : ''}`}
                    onClick={handleNext}
                    disabled={currentIndex === workerRequestIds.length - 1}
                    aria-label="Next request"
                >
                    <ChevronRightIcon className={styles.navIcon}/>
                </button>
            </div>
        </div>
    )
}
export default AdminWorkerRequest